import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../state/reducer'

interface AnalyticsProps {
    user?: unknown
    path?: string
}

export const Analytics: React.FC<AnalyticsProps> = () => {
    const {analyticsURL} = useSelector((state: RootState) => state.application)

    const handleLoad = (): void => {
        const iframe = document.getElementById('analytics_dashboard') as HTMLIFrameElement | null
        if (iframe?.contentWindow?.document) {
            const elmnt = iframe.contentWindow.document.getElementById('main-menu')
            if (elmnt) {
                elmnt.style.display = 'none'
            }
        }
    }

    return (
        <iframe
            id="analytics_dashboard"
            title="Analytics"
            seamless
            style={{
                height: 'calc(100vh - 30px)',
                width: '100%',
            }}
            onLoad={handleLoad}
            src={analyticsURL}
        />
    )
}
